// Вариант «Да»/«Нет» блока yes_no. Вынесен из превью, потому что в
// прохождении он обязан быть настоящей кнопкой, а в редакторе — статичной
// плашкой: фиктивных кнопок, которые ничего не делают, здесь быть не должно.
//
// Вид — как в мобилке (`quiz-block/yes-no.tsx`, макет квизов Figma): круг 96
// с плоской заливкой и белой галочкой/крестиком, подпись под кругом цветом
// варианта. После ответа невыбранный гаснет в серый.
import { blockTheme } from '@teach/ui'
import { cn } from '@/lib/utils'

const yn = blockTheme.quiz.yesNo

export type YesNoVariant = 'yes' | 'no'

// Знаки из макета: штрих 12 со скруглёнными концами в своём viewBox.
const GLYPH: Record<YesNoVariant, { w: number; h: number; viewBox: string; d: string }> = {
  yes: { w: 51, h: 33, viewBox: '0 0 199 130', d: 'M6 59.64 75.58 124 193 6' },
  no: { w: 32, h: 32, viewBox: '0 0 129 129', d: 'M6 123 123 6M6 6l117 117' },
}

interface Props {
  label: string
  variant: YesNoVariant
  /** Ответ дан, и выбрана была другая сторона — вариант серый. */
  dimmed?: boolean
  disabled?: boolean
  /** Не передан — вариант статичен (режим редактора). */
  onSelect?: () => void
}

export const YesNoOption = ({ label, variant, dimmed, disabled, onSelect }: Props) => {
  const glyph = GLYPH[variant]
  const fill = dimmed ? yn.off : yn[variant]
  const ink = dimmed ? yn.offGlyph : yn.glyph
  const text = dimmed ? yn.offText : variant === 'yes' ? yn.yesText : yn.noText
  const className = cn(
    'flex flex-col items-center gap-2.5 transition-transform duration-200',
    onSelect && !disabled ? 'active:scale-95' : null,
  )
  const content = (
    <>
      <span
        data-yes-no-circle
        className="flex size-24 items-center justify-center rounded-full"
        style={{ backgroundColor: fill, boxShadow: yn.shadow }}
      >
        <svg width={glyph.w} height={glyph.h} viewBox={glyph.viewBox} fill="none" aria-hidden>
          <path
            d={glyph.d}
            stroke={ink}
            strokeWidth={12}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span
        className="font-madefor text-[18px] font-semibold leading-[normal]"
        style={{ color: text }}
      >
        {label}
      </span>
    </>
  )
  return onSelect ? (
    <button type="button" className={className} disabled={disabled} onClick={onSelect}>
      {content}
    </button>
  ) : (
    <div className={className}>{content}</div>
  )
}
